import { Login, LoginCallback, LogoutCallback, SignOutCallback } from "components/auth";
import { Navigate, Route, Routes } from "react-router-dom";

const AuthRoutes = () => (
    <Routes>
        <Route index element={<Navigate to="/projects/my/in-progress" replace={true} />} />
        <Route path="login" element={<Login />} />
        <Route path="signin-oidc" element={<LoginCallback />} />
        <Route path="logout/callback" element={<LogoutCallback />} />
        <Route path="signout" element={<SignOutCallback />} />
    </Routes>
);

export default AuthRoutes;